<template>
  <div class="search-not-found">
    <button @click="handleSubmit" :disabled="disabled">未找到相应技巧</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      hash: '',
    };
  },

  props: {
    keyword: String,
    fromChannel: Number,
    searchResult: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    async handleSubmit() {
      const { keyword, fromChannel, searchResult } = this;

      if (!this.hash) {
        this.hash = await this.$service.learning.getFbToken().catch(() => '');
      }

      this.$service.learning
        .submitFeedback({
          feedback: keyword,
          fromChannel,
          searchResult,
          hash: this.hash,
        })
        .then((res) => {
          const msg = res.msg;
          let icon = 'iconic_smile';

          if (res && res.code === 200) {
            icon = 'iconic_success';
            this.disabled = true;
          }

          this.$toast(msg, icon, 3000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-not-found {
  text-align: center;
  margin: 20px 0;

  > button {
    font-size: 14px;
    line-height: 20px;
    color: #999999;
    text-decoration: underline;
    border: 0;
    background: transparent;
    outline: none;
    cursor: pointer;

    &:hover {
      color: #222226;
    }

    &:disabled {
      color: #999999;
      cursor: not-allowed;
    }
  }
}
</style>